import { Link } from 'react-router-dom';
import { Instagram, Facebook, Youtube, Mail, Phone, MapPin } from 'lucide-react';
import { useStore } from '../admin/context/ProductStore';
import './Footer.css';

export default function Footer() {
  const { settings } = useStore();

  return (
    <footer className="footer">
      <div className="footer-top container">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            {settings?.logo ? (
              <img src={settings.logo} alt="KOA" className="footer-logo-img" />
            ) : (
              <img src="/koa-logo.png" alt="KOA" className="footer-logo-img" />
            )}
          </Link>
          <p className="footer-tagline">
            India's most trusted premium dry fruits & nuts brand. Sourced directly from farms, delivered fresh to your doorstep.
          </p>
          <div className="footer-social">
            <a href="https://www.instagram.com/koa_dryfruits_spices" target="_blank" rel="noreferrer" className="social-link" aria-label="Instagram">
              <Instagram size={18} />
            </a>
            <a href="https://www.facebook.com/koadryfruits/" target="_blank" rel="noreferrer" className="social-link" aria-label="Facebook">
              <Facebook size={18} />
            </a>
            <a href="https://youtube.com/@KOADryFruits" target="_blank" rel="noreferrer" className="social-link" aria-label="YouTube">
              <Youtube size={18} />
            </a>

          </div>
        </div>

        <div className="footer-links-grid">
          <div className="footer-col">
            <h4 className="footer-col-title">Company</h4>
            <ul>
              <li key="About Us"><Link to="/about" className="footer-link">About Us</Link></li>
              <li key="Blog"><Link to="/blog" className="footer-link">Blog</Link></li>
              <li key="Track Order"><Link to="/track-order" className="footer-link">Track Order</Link></li>
              <li key="Contact Us"><Link to="/contact" className="footer-link">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Support</h4>
            <ul>
              {[
                { name: 'FAQs', href: '/contact' },
                { name: 'Return Policy', href: '/return-policy' },
                { name: 'Shipping Policy', href: '/shipping-policy' },
                { name: 'Privacy Policy', href: '/privacy-policy' },
                { name: 'Terms of Service', href: '/terms-of-service' }
              ].map(item => (
                <li key={item.name}><Link to={item.href} className="footer-link">{item.name}</Link></li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Contact</h4>
            <ul className="contact-list">
              <li>
                <Mail size={14} className="contact-icon" />
                <a href="mailto:koadryfruits2025@gmail.com" className="footer-link">koadryfruits2025@gmail.com</a>
              </li>
              <li>
                <Phone size={14} className="contact-icon" />
                <a href="tel:+916367465206" className="footer-link">+91 6367465206</a>
              </li>
              <li>
                <MapPin size={14} className="contact-icon" />
                <span className="footer-link">G-31-A, Sector 2, VIDHYADHAR ENCLAVE –II, Central Spine, Vidyadhar Nagar, Jaipur, Rajasthan 302039</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-trust container">
        <div className="trust-item">
          <img src="https://upload.wikimedia.org/wikipedia/commons/a/ab/Ssl_certificate_icon.svg" alt="" className="trust-icon" />
          <span>100% Secure Payments</span>
        </div>
        <div className="trust-item">
          <span className="trust-emoji">🌿</span>
          <span>No Preservatives</span>
        </div>
        <div className="trust-item">
          <span className="trust-emoji">🚚</span>
          <span>Free Delivery ₹599+</span>
        </div>
        <div className="trust-item">
          <span className="trust-emoji">↩️</span>
          <span>Easy Returns</span>
        </div>

      </div>

      <div className="footer-bottom container">
        <p>
          © {new Date().getFullYear()} KOA. All rights reserved. | <a href="https://thestarsmedia.com/" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}}>Designed & Developed by Starsmedia</a>
        </p>
        <div className="payment-icons">
          <span className="payment-chip">Visa</span>
          <span className="payment-chip">Mastercard</span>
          <span className="payment-chip">UPI</span>
          <span className="payment-chip">Razorpay</span>
          <span className="payment-chip">COD</span>
        </div>
      </div>
    </footer>
  );
}
